import React from 'react';
import { Form, Select } from 'antd';
import { useGetTransportLinesStatistics } from 'api/statistic/use-get-transport-lines-statistics';
import type { ITransportLineFormSelectProps } from './types';

export const TransportLineFormSelect: React.FC<ITransportLineFormSelectProps> = (props) => {
  const { name, label, placeholder, className, rootClassName, rules, allowClear, disabled, onChange } = props;
  const { data: transportLines } = useGetTransportLinesStatistics();

  const options = transportLines?.map((line) => ({ value: line.slug, label: line.name }));

  return (
    <Form.Item name={name} label={label} className={className} rootClassName={rootClassName} rules={rules}>
      <Select
        options={options}
        placeholder={placeholder}
        allowClear={allowClear}
        disabled={disabled}
        onChange={onChange}
      />
    </Form.Item>
  );
};
